/**
 * Fancybox lightbox conditional loading
 * Only loads Fancybox if elements with [data-fancybox] exist on the page
 *
 * @package StandOut
 * @since 2.0.0
 */
import { onDomReady } from "../utils/dom-ready";
onDomReady(() => {
    const fancyboxElements = document.querySelectorAll("[data-fancybox]");
    if (fancyboxElements.length > 0) {
        Promise.all([import("@fancyapps/ui"), import("@fancyapps/ui/dist/fancybox/fancybox.css")])
            .then(([{ Fancybox }]) => {
            globalThis.Fancybox = Fancybox;
            const event = new CustomEvent("fancybox-loaded", {
                bubbles: true,
            });
            window.dispatchEvent(event);
        })
            .catch((error) => {
            console.error("Failed to load Fancybox:", error);
        });
    }
});
